/* ============================================================================
   sf-card-bio.js — CRD-02 Athletenkarte (snippets/sf-card-bio.liquid), 24.09.2026
   Umschalter (+/x) klappt die Bio in der Namensleiste auf und zu, Esc
   schliesst und gibt den Fokus an den Umschalter zurueck. Ein Listener fuer
   die ganze Seite (Library und Sections), daher kein doppeltes Binden.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__sfCardBio) return;
  window.__sfCardBio = true;

  function setOpen(card, btn, open) {
    card.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var name = (card.querySelector('.sfui-card-bio__name') || {}).textContent || '';
    btn.setAttribute('aria-label', name + (open ? ': Details schließen' : ': mehr erfahren'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sf-card-bio-toggle]') : null;
    if (!btn) return;
    var card = btn.closest('[data-sf-card-bio]');
    if (card) setOpen(card, btn, !card.classList.contains('is-open'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !e.target.closest) return;
    var card = e.target.closest('[data-sf-card-bio].is-open');
    if (!card) return;
    var btn = card.querySelector('[data-sf-card-bio-toggle]');
    if (!btn) return;
    setOpen(card, btn, false);
    btn.focus();
  });
})();
